import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CommonDataService } from '@app/services/common-data/common-data.service';

@Component({
  selector: 'trustpilot-badge',
  templateUrl: './trustpilot-badge.component.html',
  styleUrl: './trustpilot-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrustpilotBadgeComponent {
  commonDataService = inject(CommonDataService);
}
